import Image from "components/Image"
import CallToAction from "components/CallToAction"
import Divider from "components/DynamicComponent/atoms/Divider"

export default function BookCard({ name, cover_image, slug }) {
  return (
    <article className="flex flex-col gap-6 bg-white px-6 py-9">
      <Image
        src={
          cover_image?.filename && cover_image.filename !== ""
            ? cover_image.filename
            : "/assets/team-member-placeholder.svg"
        }
        alt={cover_image.alt}
        width={300}
        height={250}
        className="w-full"
      />
      <Divider a11yHidden />
      <h3 className="text-center text-m1 text-primary font-primary font-semibold w-full">{name}</h3>
      <CallToAction href={slug} className="table mx-auto">
        Get Our Free Book
      </CallToAction>
    </article>
  )
}
